<template>
  <div v-if="visible" class="modal-overlay w-full h-full">
    <transition name="modal">
      <div class="popup popup--confirm">
        <popup-header
          :title="data.header"
          @close="closePopup"
          :showClose="showClose"
        />
        <div
          class="popup__content popup__content--confirm"
          :class="additionalClass"
        >
          <span
            class="text-md font-semibold dark:text-primary-white"
            v-if="data.textTitle !== undefined"
            >{{ data.textTitle }}</span
          >
          <p
            v-if="data.text !== undefined"
            class="text-xs font-light dark:text-primary-white"
            v-html="data.text"
          ></p>
          <Input
            v-if="showInput"
            v-model="input"
            class="border-none !h-10 py-1 gap-[18px] bg-greyscale-185 dark:!bg-[#292D35]"
            :darkModeClass="true"
          />
        </div>
        <div class="popup__footer">
          <Button
            v-if="data.actions.cancel != null"
            class="secondary !border-none !px-5 h-7 text-[10px] font-medium !rounded hover:bg-greyscale-200"
            @click="action(false)"
          >
            {{ data.actions.cancel }}
          </Button>
          <Button
            v-if="data.actions.confirm != null"
            class="primary h-7 !px-5 text-[10px] font-bold !rounded"
            @click="action(true)"
          >
            {{ data.actions.confirm }}
          </Button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PopupHeader from "@/components/PopupHeader";
import Button from "@/components/Button";
import Input from "@/components/Input";
export default {
  name: "ConfirmPopup",
  components: { PopupHeader, Button, Input },
  data() {
    return {
      data: null,
      input: "",
    };
  },
  methods: {
    ...mapActions(["emitConfirmData"]),
    closePopup() {
      this.data = null;
    },
    action(isConfirm) {
      if (this.data.callback != null) {
        this.data.callback(isConfirm, this.input);
      }
      this.emitConfirmData(null);
    },
  },
  computed: {
    ...mapGetters(["getConfirmData"]),
    visible() {
      return this.data !== null;
    },
    showInput() {
      return this.data?.showInput !== undefined && this.data?.showInput;
    },
    additionalClass() {
      return this.data?.class ?? "";
    },
    showClose() {
      return this.data?.showClose ?? true;
    },
  },
  watch: {
    getConfirmData: {
      handler(value) {
        this.data = value;
        this.input = this.data?.defaultInput ?? "";
      },
    },
  },
};
</script>

<style scoped>
@import "index.module.css";
</style>
